import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SCROLL_THROTTLE_MS } from '@angular/material';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.css']
})
export class PremiumComponent implements OnInit {
  flaggif=0;
  flagvid=0;
  flagnutri=0;
  flagrec=0;
  quote=[
    "Once you learn to quit, it becomes a habit. ― Vince Lombardi Jr.","Want to be respected? Be consistent.","Love yourself enough to live a healthy lifestyle.","Starve your distractions. Feed your focus. – Unknown","If it doesn’t challenge you it wont change you. – Unknown","When I lost all of my excuses I found my results.","A year from now you may wish you had started today. – Karen Lamb","When you feel like stopping…think about why you started.","You are the only one who can limit your greatness. – Unknown","It’s never too late and you’re never too old to become better.","Don’t give up on your dreams, or your dreams will give up on you. – John Wooden","There are no shortcuts to living your greatest life and becoming your best self.","Your desire to change must be greater than your desire to stay the same.","Most people fail, not because of lack of desire, but, because of lack of commitment. – Vince Lombardi","The only person you are destined to become is the person you decide to be. – Ralph Waldo Emerson","Don’t stop until you’re proud.","If you get tired, learn to rest, not quit.","Look in the mirror. That’s your competition. – John Assaraf","You are much stronger than you think.","Tough times don’t last. Tough people do. – Robert H. Schuller","You are what you do, not what you say you’ll do.","Someone busier than you is working out right now.","Put all excuses aside and remember this: YOU are capable. – Zig Ziglar","If you want it, you’ll find a way. If you don’t, you’ll find an excuse.","Start where you are. Do what you can. Never stop. Keep going.","Stop doubting yourself. Work hard and make it happen. – Unknown","You will never always be motivated. You have to learn to be disciplined. – Unknown","When your body feels like giving up, that’s when your workout really starts.","Some people want it to happen, some wish it would happen, others make it happen. – Michael Jordan","Fall in love with taking care of your body.","What you eat in private will show up in public. – Unknown","If you think living healthy is expensive, try illness. – Unknown","The groundwork for all happiness is good health. – Leigh Hunt","A healthy mind and fit body is how you express your soul.","Our bodies are our gardens – our wills are our gardeners. – William Shakespeare","Eat well. Move daily. Hydrate often. Sleep lots. Love your body.","Sweat is magic. Cover yourself in it daily to grant your health wishes.","Losing weight is hard. Being overweight is hard. Choose your hard.","Workout because you love yourself, not because you hate your body.","Health is like money, we never have a true idea of its value until we lose it.","Want to be happy? Working out releases endorphins and endorphins make you happy.","Exercise is king. Nutrition is queen. Put them together and you’ve got a kingdom. – Jack LaLanne","Physical fitness is not only one of the most important keys to a healthy body, it is the basis of dynamic and creative intellectual activity. – John F. Kennedy","You said ‘tomorrow’ yesterday. – Unknown","Strive for progress, not perfection.","Don’t shrink your goal. Increase your effort.","One day I’ll be at the place I always wanted to be.","Focus on your goal. Don’t look in any direction but ahead.","Success is what comes after your stop making excuses. – Luis Galarza","You don’t get what you wish for. You get what you work for. – Unknown","Discipline is the bridge between goals and accomplishment. – Jim Rohn","To achieve great things, you must step out of your comfort zone.","The pain you feel today will be the strength you feel tomorrow. – Arnold Schwarzenegger","You can only reach your goals through commitment, consistency, and hard work.","Setting goals is the first step into turning the invisible into the visible. – Tony Robbins","Set a goal so big that you can’t achieve it until you grow into the person who can. – Unknown","In two weeks, you’ll feel it. In four weeks, you’ll see it. In eight weeks, you’ll hear it.","Get comfortable with being uncomfortable! – Jillian Michaels","If you’re tired of starting over, stop giving up.","A one hour workout is 4% of your day. No excuses.","Your life is a direct reflection of what you have worked for.","Great works are performed, not by strength, but by perseverance. – Samuel Johnson","Keep going. Everything you need will come to you at the perfect time.","The harder you work for something, the greater you’ll feel when you achieve it. – Unknown","Results happen over time, not overnight. Work hard, stay consistent, and be patient. – Unknown","Sometimes the bravest thing you can do is to keep going when you feel like giving up.","Perseverance is the hard work you do after you get tired of doing the hard work you already did. – Newt Gingrich","Sometimes you don’t realize your own strength until you come face to face with your greatest weakness. – Susan Gale","You don’t find will power, you create it. – Unknown","Confidence comes from discipline and training. – Robert Kiyosaki","You must do the thing you think you cannot do. – Eleanor Roosevelt","Life shrinks or expands in proportion to one’s courage. – Anaïs Nin","One isn’t necessarily born with courage, but one is born with potential. – Maya Angelou","The best way to gain self-confidence is to do what you are afraid to do. – Swati Sharma","Our greatest glory is not in never failing, but in rising every time we fall. – Confucius","You must have the courage and confidence to push through your weaknesses if you want to succeed.","Ability is what you’re capable of doing. Motivation determines what you do. Attitude determines how well you do it. – Lou Holtz","Believe in yourself. You are braver than you think, more talented than you know, and capable of more than you imagine. – Roy T. Bennett","Nothing will work unless you do. – John Wooden","Pain is temporary. Quitting lasts forever. – Lance Armstrong","Don’t train to be skinny. Train to be a bad ass. – Demi Lovato","I train to be the best in the world on my worst day. – Ronda Rousey","Every champion was once a contender that refused to give up. – Sylvester Stallone","I think in life you should work on yourself until the day you die. – Serena Williams","Blood, sweat and respect. First two you give. Last one you earn. – The Rock","You must expect great things of yourself before you can do them. – Michael Jordan","There’s no secret formula. I lift heavy, work hard, and aim to be the best. – Ronnie Coleman","The muscle and the mind must become one. One without the other is zero. – Lee Haney","Living a healthy lifestyle will only deprive you of poor health, lethargy, and fat. – Jill Johnson","Today I will do what others won’t, so tomorrow I can accomplish what others can’t. – Jerry Rice.","I don’t count my sit-ups; I only start counting when it starts hurting because they’re the only ones that count. – Muhammad Ali","Strength does not come from winning. Your struggles develop your strengths. When you go through hardships and decide not to surrender, that is strength. – Arnold Schwarzenegger","Stop whining.Stop crying.Stop thinking “poor me”.It’s time to put on your big boy pants and man up!"
    ];
    i=Math.floor(this.quote.length * Math.random()); 
    // @Inject(DOCUMENT) private _document
  constructor(public dialog: MatDialog) { }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
}
  myimage1:string="https://i.pinimg.com/originals/df/71/37/df713744d60483450acd7af7fb1cf5b0.jpg";
  myimage2:string="https://wallpaperaccess.com/full/858285.jpg";
  myimage3:string="https://wallpaperaccess.com/full/851863.jpg";
  myimage4:string="https://motivationquotes.org/wp-content/uploads/2019/04/workout-motivation-quotes-wallpaper-hd.jpg";
  myimage5:string="https://i.pinimg.com/originals/15/4f/a3/154fa39934e6b3b72ca44a1eb3b5c204.jpg";
  myimage6:string="https://quotesideas.com/wp-content/uploads/2015/10/Beast-motivational-bodybuilding-hd.jpg";
  imageUrls: (string)[] = [
    this.myimage1,this.myimage2,this.myimage3,this.myimage4,this.myimage5,this.myimage6
   
 ];
 height: string = '400px';
  minHeight: string;
  arrowSize: string = '30px';
  showArrows: boolean = true;
  disableSwiping: boolean = false;
  autoPlay: boolean = true;
  autoPlayInterval: number = 3333;
  stopAutoPlayOnSlide: boolean = true;
  debug: boolean = false;
  backgroundSize: string = 'cover';
  backgroundPosition: string = 'center center';
  backgroundRepeat: string = 'no-repeat';
  showDots: boolean = true;
  dotColor: string = '#FFF';
  showCaptions: boolean = true;
  captionColor: string = '#FFF';
  captionBackground: string = 'rgba(0, 0, 0, .35)';
  lazyLoad: boolean = false;
  hideOnNoSlides: boolean = false;
  width: string = '80%';
  fullscreen: boolean = false;
  enableZoom: boolean = true;
  enablePan: boolean = false;
  noLoop: boolean = false;
 

  ngOnInit() {
    // this._document.body.style.background = '#E9E9E9';
  }
  flag1=0;
  flag2=0;
  flag3=0;
  flag4=0;
  flag5=0;
  flag6=0;
  flag7=0;
  flag8=0;
  flag9=0;
  flag10=0;
  flag11=0;
  flag12=0;
  flag13=0;
  flag14=0;
  flag15=0;
  flag16=0;
  flag17=0;
  flag18=0;
  flag19=0;
  flag20=0;
  flag21=0;
  flag22=0;
  flag23=0;
  flag24=0;
  flag25=0;
  flag26=0;
  flag27=0;
  flag28=0;
  flag29=0;
  flag30=0;
  flag31=0;
  flag32=0;
  flag33=0;
  flag34=0;
  flag35=0;
  flag36=0;
  flag37=0;
  flag38=0;
  flag39=0;
  flag40=0;
  flag41=0;
  flag42=0;
  flag43=0;
  flag44=0;
  flag45=0;
  flag46=0;
  newsletter:String="";
  loadpic1(){
    this.flag1=1;
    
  }
  hidepic1(){
    this.flag1=0;
  }
  loadpic2(){
    this.flag2=1;
    
  }
  hidepic2(){
    this.flag2=0;
  }
  loadpic3(){
    this.flag3=1;
    
  }
  hidepic3(){
    this.flag3=0;
  }
  loadpic4(){
    this.flag4=1;
    
  }
  hidepic4(){
    this.flag4=0;
  }
  loadpic5(){
    this.flag5=1;
    
  }
  hidepic5(){
    this.flag5=0;
  }
  loadpic6(){
    this.flag6=1;
    
  }
  hidepic6(){
    this.flag6=0;
  }
  loadpic7(){
    this.flag7=1;
    
  }
  hidepic7(){
    this.flag7=0;
  }
  loadpic8(){
    this.flag8=1;
    
  }
  hidepic8(){
    this.flag8=0;
  }
  loadpic9(){
    this.flag9=1;
    
  }
  hidepic9(){
    this.flag9=0;
  }
  loadpic10(){
    this.flag10=1;
    
  }
  hidepic10(){
    this.flag10=0;
  }
  loadpic11(){
    this.flag11=1;
    
  }
  hidepic11(){
    this.flag11=0;
  }
  loadpic12(){
    this.flag12=1;
    
  }
  hidepic12(){
    this.flag12=0;
  }
  loadpic13(){
    this.flag13=1;
    
  }
  hidepic13(){
    this.flag13=0;
  }
  loadpic14(){
    this.flag14=1;
    
  }
  hidepic14(){
    this.flag14=0;
  }
  loadpic15(){
    this.flag15=1;
    
  }
  hidepic15(){
    this.flag15=0;
  }
  loadpic16(){
    this.flag16=1;
    
  }
  hidepic16(){
    this.flag16=0;
  }
  loadpic17(){
    this.flag17=1;
    
  }
  hidepic17(){
    this.flag17=0;
  }
  loadpic18(){
    this.flag18=1;
    
  }
  hidepic18(){
    this.flag18=0;
  }
  loadpic19(){
    this.flag19=1;
    
  }
  hidepic19(){
    this.flag19=0;
  }
  loadpic20(){
    this.flag20=1;
    
  }
  hidepic20(){
    this.flag20=0;
  }
  loadpic21(){
    this.flag21=1;
    
  }
  hidepic21(){
    this.flag21=0;
  }
  loadpic22(){
    this.flag22=1;
    
  }
  hidepic22(){
    this.flag22=0;
  }
  loadpic23(){
    this.flag23=1;
    
  }
  hidepic23(){
    this.flag23=0;
  }
  loadpic24(){
    this.flag24=1;
    
  }
  hidepic24(){
    this.flag24=0;
  }
  loadpic25(){
    this.flag25=1;
    
  }
  hidepic25(){
    this.flag25=0;
  }
  loadpic26(){
    this.flag26=1;
    
  }
  hidepic26(){
    this.flag26=0;
  }
  loadpic27(){
    this.flag27=1;
    
  }
  hidepic27(){
    this.flag27=0;
  }
  loadpic28(){
    this.flag28=1;
    
  }
  hidepic28(){
    this.flag28=0;
  }
  loadpic29(){
    this.flag29=1;
    
  }
  hidepic29(){
    this.flag29=0;
  }
  loadpic30(){
    this.flag30=1;
    
  }
  hidepic30(){
    this.flag30=0;
  }
  loadpic31(){
    this.flag31=1;
    
  }
  hidepic31(){
    this.flag31=0;
  }
  loadpic32(){
    this.flag32=1;
    
  }
  hidepic32(){
    this.flag32=0;
  }
  loadpic33(){
    this.flag33=1;
    
  }
  hidepic33(){
    this.flag33=0;
  }
  loadpic34(){
    this.flag34=1;
    
  }
  hidepic34(){
    this.flag34=0;
  }
  loadpic35(){
    this.flag35=1;
    
  }
  hidepic35(){
    this.flag35=0;
  }
  loadpic36(){
    this.flag36=1;
    
  }
  hidepic36(){
    this.flag36=0;
  }
  loadpic37(){
    this.flag37=1;
    
  }
  hidepic37(){
    this.flag37=0;
  }
  loadpic38(){
    this.flag38=1;
    
  }
  hidepic38(){
    this.flag38=0;
  }
  loadpic39(){
    this.flag39=1;
    
  }
  hidepic39(){
    this.flag39=0;
  }
  loadpic40(){
    this.flag40=1;
    
  }
  hidepic40(){
    this.flag40=0;
  }
  loadpic41(){
    this.flag41=1;
    
  }
  hidepic41(){
    this.flag41=0;
  }
  loadpic42(){
    this.flag42=1;
    
  }
  hidepic42(){
    this.flag42=0;
  }
  loadpic43(){
    this.flag43=1;
    
  }
  hidepic43(){
    this.flag43=0;
  }
  loadpic44(){
    this.flag44=1;
    
  }
  hidepic44(){
    this.flag44=0;
  }
  loadpic45(){
    this.flag45=1;
    
  }
  hidepic45(){
    this.flag45=0;
  }
  loadpic46(){
    this.flag46=1;
    
  }
  hidepic46(){
    this.flag46=0;
  }
  flagweight=0;
flagmuscle=0;
dietPlan(){
  var a = prompt("Fat Loss/Muscle Building")
  if(a == "Fat Loss")
  {
    this.flagweight = 1;
    this.flagmuscle = 0;
  }
  else if(a == "Muscle Building")
  {
    this.flagmuscle = 1;
    this.flagweight = 0;
  }
  else{
    alert("Invalid Credentials");
  }
}
  food(){  
    this.flagnutri=1;

    var xhr=new XMLHttpRequest();

 var url1="https://edamam-food-and-grocery-database.p.rapidapi.com/parser?ingr=";
 var url2=prompt("Write the name of the food");
 var url=url1+url2;
 xhr.open("GET",url);
xhr.setRequestHeader("x-rapidapi-host", "edamam-food-and-grocery-database.p.rapidapi.com");
xhr.setRequestHeader("x-rapidapi-key", "23afcb7ce7msh54dd1061c86521cp1c66bejsn627983c745fb");
xhr.onreadystatechange=test;
function test(){
 if(this.status==200 && this.readyState==4){
     var res_data=JSON.parse(this.responseText);
     console.log(res_data);
     var rec=document.getElementById("titlerec");
      rec.innerHTML="Nutrition Facts";
     //first
    //  var a=document.getElementById("category");
    //  a.innerHTML="Category: "+res_data.hints[0].food.category;
    //  var a=document.getElementById("label");
    //  a.innerHTML="Label: "+res_data.hints[0].food.label;
     var img=document.getElementById("image1");
     if(res_data.hints[0].food.image!=null){
     var imgset=res_data.hints[0].food.image;
     img.setAttribute('src',imgset);}
     else{
     img.setAttribute('src','assets/img/nutritionpic.jpg');
     }
     if(res_data.hints[0].food.foodContentsLabel!=null){
     var b=document.getElementById('fcontent1');
     b.innerHTML="Food Content: "+res_data.hints[0].food.foodContentsLabel;}
     var b=document.getElementById("ul1");
     b.innerHTML="Nutrition:";                                 
     var c=document.getElementById('li1');
     c.innerHTML="1) Carbs: "+res_data.hints[0].food.nutrients.CHOCDF;
     var c=document.getElementById('li2');
     c.innerHTML="2) Calories: "+res_data.hints[0].food.nutrients.ENERC_KCAL;
     var c=document.getElementById('li3');
     c.innerHTML="3) Fat: "+res_data.hints[0].food.nutrients.FAT;
     var c=document.getElementById('li4');
     c.innerHTML="4) Fibre: "+res_data.hints[0].food.nutrients.FIBTG;
     var c=document.getElementById('li5');
     c.innerHTML="5) Protein: "+res_data.hints[0].food.nutrients.PROCNT;
    //  //second
    //  var a=document.getElementById("category2");
    //  a.innerHTML="Category: "+res_data.hints[1].food.category;
    //  var a=document.getElementById("label2");
    //  a.innerHTML="Label: "+res_data.hints[1].food.label;
    //  var img=document.getElementById("image2");
    //  if(res_data.hints[1].food.image!=null){
    //  var imgset=res_data.hints[1].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[1].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent2');
    //  b.innerHTML="Food Content: "+res_data.hints[1].food.foodContentsLabel;}
    //  var b=document.getElementById("2ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('2li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[1].food.nutrients.CHOCDF;
    //  var c=document.getElementById('2li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[1].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('2li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[1].food.nutrients.FAT;
    //  var c=document.getElementById('2li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[1].food.nutrients.FIBTG;
    //  var c=document.getElementById('2li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[1].food.nutrients.PROCNT;
    //  //third
    //  var a=document.getElementById("category3");
    //  a.innerHTML="Category: "+res_data.hints[2].food.category;
    //  var a=document.getElementById("label3");
    //  a.innerHTML="Label: "+res_data.hints[2].food.label;
    //  var img=document.getElementById("image3");
    //  if(res_data.hints[2].food.image!=null){
    //  var imgset=res_data.hints[2].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[2].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent3');
    //  b.innerHTML="Food Content: "+res_data.hints[2].food.foodContentsLabel;}
    //  var b=document.getElementById("3ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('3li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[2].food.nutrients.CHOCDF;
    //  var c=document.getElementById('3li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[2].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('3li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[2].food.nutrients.FAT;
    //  var c=document.getElementById('3li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[2].food.nutrients.FIBTG;
    //  var c=document.getElementById('3li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[2].food.nutrients.PROCNT;
    //  //fourth
    //  var a=document.getElementById("category4");
    //  a.innerHTML="Category: "+res_data.hints[3].food.category;
    //  var a=document.getElementById("label4");
    //  a.innerHTML="Label: "+res_data.hints[3].food.label;
    //  var img=document.getElementById("image4");
    //  if(res_data.hints[3].food.image!=null){
    //  var imgset=res_data.hints[3].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[3].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent4');
    //  b.innerHTML="Food Content: "+res_data.hints[3].food.foodContentsLabel;}
    //  var b=document.getElementById("4ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('4li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[3].food.nutrients.CHOCDF;
    //  var c=document.getElementById('4li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[3].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('4li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[3].food.nutrients.FAT;
    //  var c=document.getElementById('4li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[3].food.nutrients.FIBTG;
    //  var c=document.getElementById('4li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[3].food.nutrients.PROCNT;
    //  //fifth
    //  var a=document.getElementById("category5");
    //  a.innerHTML="Category: "+res_data.hints[4].food.category;
    //  var a=document.getElementById("label5");
    //  a.innerHTML="Label: "+res_data.hints[4].food.label;
    //  var img=document.getElementById("image5");
    //  if(res_data.hints[4].food.image!=null){
    //  var imgset=res_data.hints[4].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[4].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent5');
    //  b.innerHTML="Food Content: "+res_data.hints[4].food.foodContentsLabel;}
    //  var b=document.getElementById("5ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('5li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[4].food.nutrients.CHOCDF;
    //  var c=document.getElementById('5li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[4].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('5li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[4].food.nutrients.FAT;
    //  var c=document.getElementById('5li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[4].food.nutrients.FIBTG;
    //  var c=document.getElementById('5li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[4].food.nutrients.PROCNT;
    //  //sixth
    //  var a=document.getElementById("category6");
    //  a.innerHTML="Category: "+res_data.hints[5].food.category;
    //  var a=document.getElementById("label6");
    //  a.innerHTML="Label: "+res_data.hints[5].food.label;
    //  var img=document.getElementById("image6");
    //  if(res_data.hints[5].food.image!=null){
    //  var imgset=res_data.hints[5].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[5].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent6');
    //  b.innerHTML="Food Content: "+res_data.hints[5].food.foodContentsLabel;}
    //  var b=document.getElementById("6ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('6li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[5].food.nutrients.CHOCDF;
    //  var c=document.getElementById('6li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[5].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('6li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[5].food.nutrients.FAT;
    //  var c=document.getElementById('6li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[5].food.nutrients.FIBTG;
    //  var c=document.getElementById('6li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[5].food.nutrients.PROCNT;
    //  //seventh
    //  var a=document.getElementById("category7");
    //  a.innerHTML="Category: "+res_data.hints[6].food.category;
    //  var a=document.getElementById("label7");
    //  a.innerHTML="Label: "+res_data.hints[6].food.label;
    //  var img=document.getElementById("image7");
    //  if(res_data.hints[6].food.image!=null){
    //  var imgset=res_data.hints[6].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[6].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent7');
    //  b.innerHTML="Food Content: "+res_data.hints[6].food.foodContentsLabel;}
    //  var b=document.getElementById("7ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('7li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[6].food.nutrients.CHOCDF;
    //  var c=document.getElementById('7li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[6].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('7li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[6].food.nutrients.FAT;
    //  var c=document.getElementById('7li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[6].food.nutrients.FIBTG;
    //  var c=document.getElementById('7li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[6].food.nutrients.PROCNT;
    //  //eighth
    //  var a=document.getElementById("category8");
    //  a.innerHTML="Category: "+res_data.hints[7].food.category;
    //  var a=document.getElementById("label8");
    //  a.innerHTML="Label: "+res_data.hints[7].food.label;
    //  var img=document.getElementById("image8");
    //  if(res_data.hints[7].food.image!=null){
    //  var imgset=res_data.hints[7].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[7].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent8');
    //  b.innerHTML="Food Content: "+res_data.hints[7].food.foodContentsLabel;}
    //  var b=document.getElementById("8ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('8li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[7].food.nutrients.CHOCDF;
    //  var c=document.getElementById('8li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[7].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('8li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[7].food.nutrients.FAT;
    //  var c=document.getElementById('8li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[7].food.nutrients.FIBTG;
    //  var c=document.getElementById('8li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[7].food.nutrients.PROCNT;
    //  //ninth
    //  var a=document.getElementById("category9");
    //  a.innerHTML="Category: "+res_data.hints[8].food.category;
    //  var a=document.getElementById("label9");
    //  a.innerHTML="Label: "+res_data.hints[8].food.label;
    //  var img=document.getElementById("image9");
    //  if(res_data.hints[8].food.image!=null){
    //  var imgset=res_data.hints[8].food.image;
    //  img.setAttribute('src',imgset);}
    //  else{
    //  img.setAttribute('src','https://images.newscientist.com/wp-content/uploads/2019/11/13140642/gettyimages-855098134.jpg');
    //  }
    //  if(res_data.hints[8].food.foodContentsLabel!=null){
    //  var b=document.getElementById('fcontent9');
    //  b.innerHTML="Food Content: "+res_data.hints[8].food.foodContentsLabel;}
    //  var b=document.getElementById("9ul1");
    //  b.innerHTML="Nutrition:";
    //  var c=document.getElementById('9li1');
    //  c.innerHTML="1) Carbs: "+res_data.hints[8].food.nutrients.CHOCDF;
    //  var c=document.getElementById('9li2');
    //  c.innerHTML="2) Calories: "+res_data.hints[8].food.nutrients.ENERC_KCAL;
    //  var c=document.getElementById('9li3');
    //  c.innerHTML="3) Fat: "+res_data.hints[8].food.nutrients.FAT;
    //  var c=document.getElementById('9li4');
    //  c.innerHTML="4) Fibre: "+res_data.hints[8].food.nutrients.FIBTG;
    //  var c=document.getElementById('9li5');
    //  c.innerHTML="5) Protein: "+res_data.hints[8].food.nutrients.PROCNT;
   
 }
}
xhr.send();
 }
 rcpe(){
   this.flagrec=1;
  var xhr=new XMLHttpRequest();

var url1="https://recipe-puppy.p.rapidapi.com/?q=";
var url2=prompt("Search for ingredients of dishes");
var url=url1+url2;
xhr.open("GET",url);
xhr.setRequestHeader("x-rapidapi-host", "recipe-puppy.p.rapidapi.com");
xhr.setRequestHeader("x-rapidapi-key", "23afcb7ce7msh54dd1061c86521cp1c66bejsn627983c745fb");
xhr.onreadystatechange=test;
function test(){
if(this.status==200 && this.readyState==4){
 
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var rec=document.getElementById("titlerec1");
      rec.innerHTML="Recipe";
  //first
  var pehla=document.getElementById('title1');
  pehla.innerHTML=res_data.results[0].title;
  var a=document.getElementById('link1');
  var aset=res_data.results[0].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img111');
  if(res_data.results[0].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[0].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing1');
  c.innerHTML="Ingredients: "+res_data.results[0].ingredients;
 //second
  var pehla=document.getElementById('title2');
  pehla.innerHTML=res_data.results[1].title;
  var a=document.getElementById('link2');
  var aset=res_data.results[1].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img222');
  if(res_data.results[1].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[1].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing2');
  c.innerHTML="Ingredients: "+res_data.results[1].ingredients;
  //third
  var pehla=document.getElementById('title3');
  pehla.innerHTML=res_data.results[2].title;
  var a=document.getElementById('link3');
  var aset=res_data.results[2].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img333');
  if(res_data.results[2].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[2].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing3');
  c.innerHTML="Ingredients: "+res_data.results[2].ingredients;
  //fourth
  var pehla=document.getElementById('title4');
  pehla.innerHTML=res_data.results[3].title;
  var a=document.getElementById('link4');
  var aset=res_data.results[3].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img444');
  if(res_data.results[3].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[3].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing4');
  c.innerHTML="Ingredients: "+res_data.results[3].ingredients;
  //fifth
  var pehla=document.getElementById('title5');
  pehla.innerHTML=res_data.results[4].title;
  var a=document.getElementById('link5');
  var aset=res_data.results[4].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img555');
  if(res_data.results[4].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[4].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing5');
  c.innerHTML="Ingredients: "+res_data.results[4].ingredients;
  //sixth
  var pehla=document.getElementById('title6');
  pehla.innerHTML=res_data.results[5].title;
  var a=document.getElementById('link6');
  var aset=res_data.results[5].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img666');
  if(res_data.results[5].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[5].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing6');
  c.innerHTML="Ingredients: "+res_data.results[5].ingredients;
  //seventh
  var pehla=document.getElementById('title7');
  pehla.innerHTML=res_data.results[6].title;
  var a=document.getElementById('link7');
  var aset=res_data.results[6].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img777');
  if(res_data.results[6].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[6].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing7');
  c.innerHTML="Ingredients: "+res_data.results[6].ingredients;
  //eighth
  var pehla=document.getElementById('title8');
  pehla.innerHTML=res_data.results[7].title;
  var a=document.getElementById('link8');
  var aset=res_data.results[7].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img888');
  if(res_data.results[7].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[7].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing8');
  c.innerHTML="Ingredients: "+res_data.results[7].ingredients;
  //ninth
  var pehla=document.getElementById('title9');
  pehla.innerHTML=res_data.results[8].title;
  var a=document.getElementById('link9');
  var aset=res_data.results[8].href;
  a.setAttribute('href',aset);
  var b=document.getElementById('img999');
  if(res_data.results[8].thumbnail==""){
     b.setAttribute('src','assets/img/recipepic.jpg'); 
     b.setAttribute('width',"100px");
  }
  else
  {
  var bset=res_data.results[8].thumbnail;
  b.setAttribute('src',bset);}
  b.setAttribute('title','Click here for steps in detail');
  var c=document.getElementById('ing9');
  c.innerHTML="Ingredients: "+res_data.results[8].ingredients;

}
}
xhr.send();
 }
 checkfunc(){
  var what=prompt("Video or Gif?");
    if(what=="Video"||what=="video"){
      this.srch();
    }
    else if(what=="Gif"||what=="gif"){
      this.gify();
    }
    else{
      alert("Invalid entry");
    }
}
 srch(){
   this.flagvid=1;
   var xhr=new XMLHttpRequest();
   var url1="https://youtube-search1.p.rapidapi.com/";
   var url2=prompt("Write the name of the topic");
   var url=url1+url2;
   xhr.open("GET",url);
xhr.setRequestHeader("x-rapidapi-host", "youtube-search1.p.rapidapi.com");
xhr.setRequestHeader("x-rapidapi-key", "23afcb7ce7msh54dd1061c86521cp1c66bejsn627983c745fb");
xhr.onreadystatechange=test;
function test(){
   if(this.status==200 && this.readyState==4){
       var res_data=JSON.parse(this.responseText);
       console.log(res_data);
       var pehla=document.getElementById('titleyoutube');
       pehla.innerHTML="Youtube Videos";
      //first
       var a=document.getElementById("vid1");
       if(res_data.items[0].thumbAnim!=""){
       var aset=res_data.items[0].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
    
       var a=document.getElementById("vid1");
       var aset=res_data.items[0].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch1");
       var aset=res_data.items[0].url;
       a.setAttribute('href',aset);
      //second
       var a=document.getElementById("vid2");
       if(res_data.items[1].thumbAnim!=""){
       var aset=res_data.items[1].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid2");
       var aset=res_data.items[1].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch2");
       var aset=res_data.items[1].url;
       a.setAttribute('href',aset);
      //third
      var a=document.getElementById("vid3");
      if(res_data.items[2].thumbAnim!=""){
       var aset=res_data.items[2].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid3");
       var aset=res_data.items[2].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch3");
       var aset=res_data.items[2].url;
       a.setAttribute('href',aset);
       //forth
       var a=document.getElementById("vid4");
       if(res_data.items[3].thumbAnim!=""){
       var aset=res_data.items[3].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid4");
       var aset=res_data.items[3].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch4");
       var aset=res_data.items[3].url;
       a.setAttribute('href',aset);
       //fifth
       var a=document.getElementById("vid5");
       if(res_data.items[4].thumbAnim!=""){
       var aset=res_data.items[4].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid5");
       var aset=res_data.items[4].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch5");
       var aset=res_data.items[4].url;
       a.setAttribute('href',aset);
       //sixth
       var a=document.getElementById("vid6");
       if(res_data.items[5].thumbAnim!=""){
       var aset=res_data.items[5].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid6");
       var aset=res_data.items[5].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch6");
       var aset=res_data.items[5].url;
       a.setAttribute('href',aset);
       //seventh
       var a=document.getElementById("vid7");
       if(res_data.items[6].thumbAnim!=""){
       var aset=res_data.items[6].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid7");
       var aset=res_data.items[6].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch7");
       var aset=res_data.items[6].url;
       a.setAttribute('href',aset);
       //eighth
       var a=document.getElementById("vid8");
       if(res_data.items[7].thumbAnim!=""){
       var aset=res_data.items[7].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid8");
       var aset=res_data.items[7].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch8");
       var aset=res_data.items[7].url;
       a.setAttribute('href',aset);
       //ninth
       var a=document.getElementById("vid9");
       if(res_data.items[8].thumbAnim!=""){
       var aset=res_data.items[8].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid9");
       var aset=res_data.items[8].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch9");
       var aset=res_data.items[8].url;
       a.setAttribute('href',aset);
       //tenth
       var a=document.getElementById("vid10");
       if(res_data.items[9].thumbAnim!=""){
       var aset=res_data.items[9].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid10");
       var aset=res_data.items[9].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch10");
       var aset=res_data.items[9].url;
       a.setAttribute('href',aset);
       //eleventh
       var a=document.getElementById("vid11");
       if(res_data.items[10].thumbAnim!=""){
       var aset=res_data.items[10].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid11");
       var aset=res_data.items[10].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch11");
       var aset=res_data.items[10].url;
       a.setAttribute('href',aset);
       //twelth
       var a=document.getElementById("vid12");
       if(res_data.items[11].thumbAnim!=""){
       var aset=res_data.items[11].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid12");
       var aset=res_data.items[11].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch12");
       var aset=res_data.items[11].url;
       a.setAttribute('href',aset);
       //thirteenth
       var a=document.getElementById("vid13");
       if(res_data.items[12].thumbAnim!=""){
       var aset=res_data.items[12].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid13");
       var aset=res_data.items[12].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch13");
       var aset=res_data.items[12].url;
       a.setAttribute('href',aset);
       //fourteenth
       var a=document.getElementById("vid14");
       if(res_data.items[13].thumbAnim!=""){
       var aset=res_data.items[13].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid14");
       var aset=res_data.items[13].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch14");
       var aset=res_data.items[13].url;
       a.setAttribute('href',aset);
       //fifteenth
       var a=document.getElementById("vid15");
       if(res_data.items[14].thumbAnim!=""){
       var aset=res_data.items[14].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid15");
       var aset=res_data.items[14].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch15");
       var aset=res_data.items[14].url;
       a.setAttribute('href',aset);
       //sixteenth
       var a=document.getElementById("vid16");
       if(res_data.items[15].thumbAnim!=""){
       var aset=res_data.items[15].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid16");
       var aset=res_data.items[15].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch16");
       var aset=res_data.items[15].url;
       a.setAttribute('href',aset);
       //seventeenth
       var a=document.getElementById("vid17");
       if(res_data.items[16].thumbAnim!=""){
       var aset=res_data.items[16].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid17");
       var aset=res_data.items[16].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch17");
       var aset=res_data.items[16].url;
       a.setAttribute('href',aset);
       //eighteenth
       var a=document.getElementById("vid18");
       if(res_data.items[17].thumbAnim!=""){
       var aset=res_data.items[17].thumbAnim;
       a.setAttribute('src',aset);}
       else{
         a.setAttribute('src','https://media1.tenor.com/images/b087f562c546c77c6f6750afc4d48ade/tenor.gif?itemid=13716774');
       }
       var a=document.getElementById("vid18");
       var aset=res_data.items[17].title;
       a.setAttribute('title',aset);
       var a=document.getElementById("asrch18");
       var aset=res_data.items[17].url;
       a.setAttribute('href',aset);
    
    }
                          
  }
  xhr.send();   
 }
gify(){
  this.flaggif=1;
  var xhr=new XMLHttpRequest();
  var url2=prompt("Write the name of the gif");
  var url1="https://giphy.p.rapidapi.com/v1/gifs/search?q=";
  var url3="&api_key=dc6zaTOxFJmzC";
  var url=url1+url2+url3;
  xhr.open("GET",url);
  xhr.setRequestHeader("x-rapidapi-host", "giphy.p.rapidapi.com");
  xhr.setRequestHeader("x-rapidapi-key", "23afcb7ce7msh54dd1061c86521cp1c66bejsn627983c745fb");
  xhr.onreadystatechange=test;
  function test(){
  if(this.status==200 && this.readyState==4){
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var pehla=document.getElementById("titlegif");
  pehla.innerHTML="Gifs";
  //first
  var img=document.getElementById('vidd1');
  var imgset=res_data.data[0].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd1");
  var aset=res_data.data[0].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk1");
  var aset=res_data.data[0].url;
  a.setAttribute('href',aset);
  //second
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd2');
  var imgset=res_data.data[1].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd2");
  var aset=res_data.data[1].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk2");
  var aset=res_data.data[1].url;
  a.setAttribute('href',aset);
  //third
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd3');
  var imgset=res_data.data[2].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd3");
  var aset=res_data.data[2].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk3");
  var aset=res_data.data[2].url;
  a.setAttribute('href',aset);
  //fourth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd4');
  var imgset=res_data.data[3].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd4");
  var aset=res_data.data[3].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk4");
  var aset=res_data.data[3].url;
  a.setAttribute('href',aset);
  //fifth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd5');
  var imgset=res_data.data[4].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd5");
  var aset=res_data.data[4].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk5");
  var aset=res_data.data[4].url;
  a.setAttribute('href',aset);
  //sixth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd6');
  var imgset=res_data.data[5].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd6");
  var aset=res_data.data[5].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk6");
  var aset=res_data.data[5].url;
  a.setAttribute('href',aset);
  //seventh
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd7');
  var imgset=res_data.data[6].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd7");
  var aset=res_data.data[6].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk7");
  var aset=res_data.data[6].url;
  a.setAttribute('href',aset);
  //eighth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd8');
  var imgset=res_data.data[7].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd8");
  var aset=res_data.data[7].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk8");
  var aset=res_data.data[7].url;
  a.setAttribute('href',aset);
  //ninth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd9');
  var imgset=res_data.data[8].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd9");
  var aset=res_data.data[8].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("linkk9");
  var aset=res_data.data[8].url;
  a.setAttribute('href',aset);
  //tenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd10');
  var imgset=res_data.data[9].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd10");
  var aset=res_data.data[9].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link10");
  var aset=res_data.data[9].url;
  a.setAttribute('href',aset);
  //eleventh
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd11');
  var imgset=res_data.data[10].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd11");
  var aset=res_data.data[10].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link11");
  var aset=res_data.data[10].url;
  a.setAttribute('href',aset);
  //twelveth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd12');
  var imgset=res_data.data[11].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd12");
  var aset=res_data.data[11].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link12");
  var aset=res_data.data[11].url;
  a.setAttribute('href',aset);
  //thirteenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd13');
  var imgset=res_data.data[12].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd13");
  var aset=res_data.data[12].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link13");
  var aset=res_data.data[12].url;
  a.setAttribute('href',aset);
  //fourteenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd14');
  var imgset=res_data.data[13].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd14");
  var aset=res_data.data[13].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link14");
  var aset=res_data.data[13].url;
  a.setAttribute('href',aset);
  //fifteenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd15');
  var imgset=res_data.data[14].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd15");
  var aset=res_data.data[14].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link15");
  var aset=res_data.data[14].url;
  a.setAttribute('href',aset);
  //sixteenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd16');
  var imgset=res_data.data[15].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd16");
  var aset=res_data.data[15].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link16");
  var aset=res_data.data[15].url;
  a.setAttribute('href',aset);
  //seventeenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd17');
  var imgset=res_data.data[16].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd17");
  var aset=res_data.data[16].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link17");
  var aset=res_data.data[16].url;
  a.setAttribute('href',aset);
  //eighteenth
  var res_data=JSON.parse(this.responseText);
  console.log(res_data);
  var img=document.getElementById('vidd18');
  var imgset=res_data.data[17].images.looping.mp4;
  img.setAttribute('src',imgset);
  var a=document.getElementById("vidd18");
  var aset=res_data.data[17].title;
  a.setAttribute('title',aset);
  var a=document.getElementById("link18");
  var aset=res_data.data[17].url;
  a.setAttribute('href',aset);
}
  
}
xhr.send(); 
}
subs(){
  if(this.newsletter!="")
  alert("Thanks for subscribing");
  else
  alert("Please mention your email");
}
chatbot(){
  const dialogRef = this.dialog.open(ChatbotComponent);
  dialogRef.afterClosed().subscribe(result => {
    console.log(`Dialog result: ${result}`);
  });
}
}

